// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './user-tenant-memberships-api';

export const useAddUserMembership: typeof hookExports.useAddUserMembership =
  hookExports.useAddUserMembership;
export const useListUserMemberships: typeof hookExports.useListUserMemberships =
  hookExports.useListUserMemberships;
export const useLazyListUserMemberships: typeof hookExports.useLazyListUserMemberships =
  hookExports.useLazyListUserMemberships;
export const useGetUserMembership: typeof hookExports.useGetUserMembership =
  hookExports.useGetUserMembership;
export const useLazyGetUserMembership: typeof hookExports.useLazyGetUserMembership =
  hookExports.useLazyGetUserMembership;
export const useRemoveUserFromTenant: typeof hookExports.useRemoveUserFromTenant =
  hookExports.useRemoveUserFromTenant;
export const useUpdateUserMembership: typeof hookExports.useUpdateUserMembership =
  hookExports.useUpdateUserMembership;
export const useRemoveUserMembership: typeof hookExports.useRemoveUserMembership =
  hookExports.useRemoveUserMembership;
